import React from 'react';
import {HoverShowTooltip, HoverHideTooltip}		from '../common/_Utilities.jsx';
import {StudioAwards}	from '../studio/_StudioAwards.jsx';

export class SetIcon extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg className={"icon set-icon " + classes} viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<path id="sets" d="M3,10l0,1l5,0l0,-1l-5,0Zm-1,-10l14,0c1.105,0 2,0.895 2,2l0,14c0,1.105 -0.895,2 -2,2l-14,0c-1.105,0 -2,-0.895 -2,-2l0,-14c0,-1.105 0.895,-2 2,-2Zm1,3l0,5l5,0l0,-5l-5,0Z"/>
			</svg>
		);
	}
}
export class SetIconColor extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg className={"icon set-icon--color " + classes} viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<defs>
					<rect id="path-1-set" x="2" y="2" width="20" height="20" rx="2"></rect>
					<filter x="-5.0%" y="-5.0%" width="110.0%" height="110.0%" filterUnits="objectBoundingBox" id="filter-3">
						<feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetInner1"></feOffset>
						<feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
						<feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
					</filter>
				</defs>
				<g id="nav" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="xp1_nav" transform="translate(-26.000000, -143.000000)">
						<g id="catalog" transform="translate(24.000000, 110.000000)">
							<g id="Icon/Nav/Sets" transform="translate(0.000000, 31.000000)">
								<mask id="mask-2-set" fill="white">
									<use xlinkHref="#path-1-set"></use>
								</mask>
								<g id="Rectangle" fillRule="nonzero">
									<use fill="#F7D117" xlinkHref="#path-1-set"></use>
									<use fill="black" fillOpacity="1" filter="url(#filter-3)" xlinkHref="#path-1-set"></use>
									<rect stroke="#B89C11" strokeWidth="1" strokeLinejoin="square" x="2.5" y="2.5" width="19" height="19" rx="2"></rect>
								</g>
								<rect id="Rectangle" fill="#D80000" fillRule="nonzero" mask="url(#mask-2-set)" x="5" y="5" width="9" height="8" rx="1"></rect>
								<rect id="Rectangle" stroke="#111111" strokeWidth="1" fill="#FFFFFF" fillRule="nonzero" mask="url(#mask-2-set)" x="6.5" y="7.5" width="6" height="3" rx="0.5"></rect>
								<path d="M5,14 L14,14 L14,15 L5,15 L5,14 Z M5,16 L11,16 L11,17 L5,17 L5,16 Z" id="Combined-Shape" fill="#111111" fillRule="nonzero" mask="url(#mask-2-set)"></path>
							</g>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}

export class MinifigIcon extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg className={"icon minifig-icon " + classes} viewBox="0 0 16 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<path id="minifigs" d="M3,15l-2,0c-0.552,0 -1,-0.448 -1,-1l0,-10c0,-0.552 0.448,-1 1,-1l3,0l0,-2c0,-0.552 0.448,-1 1,-1l6,0c0.552,0 1,0.448 1,1l0,2l3,0c0.552,0 1,0.448 1,1l0,10c0,0.552 -0.448,1 -1,1l-2,0l0,2l-10,0l0,-2Zm3,-7c0.552,0 1,-0.448 1,-1c0,-0.552 -0.448,-1 -1,-1c-0.552,0 -1,0.448 -1,1c0,0.552 0.448,1 1,1Zm4,0c0.552,0 1,-0.448 1,-1c0,-0.552 -0.448,-1 -1,-1c-0.552,0 -1,0.448 -1,1c0,0.552 0.448,1 1,1Zm-5,2l0,1c0,1.105 0.895,2 2,2l2,0c1.105,0 2,-0.895 2,-2l0,-1l-6,0Z"/>
			</svg>
		);
	}
}

export class MinifigIconOutline extends React.Component {
	constructor(props) {
		super(props);
	}

  render() {
		const {classes = ''} = this.props;
		
  	return (
	    <svg
	    	className={"icon minifig-icon--outline " + classes}
	      xmlns="http://www.w3.org/2000/svg"
	      viewBox="0 0 16 16"
	    >
	      <path
	        fill="#89939C"
	        d="M6.923 7.34a.833.833 0 11-1.179-1.18.833.833 0 011.179 1.18zM10.256 7.34a.833.833 0 11-1.179-1.18.833.833 0 011.179 1.18zM5.5 9.25v.833a1.666 1.666 0 001.667 1.667h1.666a1.666 1.666 0 001.667-1.667V9.25h-5z"
	      ></path>
	      <path
	        fill="#89939C"
	        fillRule="evenodd"
	        d="M11.386 15.5c.826 0 1.512-.601 1.643-1.39a2.34 2.34 0 001.376-.68 2.357 2.357 0 00.678-1.655V4.911c0-.617-.241-1.213-.678-1.656a2.34 2.34 0 00-1.665-.697h-.383a2.356 2.356 0 00-.66-1.362A2.34 2.34 0 0010.03.5H5.97a2.34 2.34 0 00-1.665.697 2.356 2.356 0 00-.66 1.362H3.26a2.34 2.34 0 00-1.665.697 2.358 2.358 0 00-.678 1.656v6.862c0 .617.241 1.213.678 1.656.37.375.855.614 1.376.68.131.789.817 1.39 1.644 1.39h6.77zm1.832-11.073a.672.672 0 00-.478-.202h-2.032V2.853a.69.69 0 00-.198-.485.673.673 0 00-.479-.201H5.97a.673.673 0 00-.479.2.691.691 0 00-.198.486v1.372H3.26a.672.672 0 00-.48.202.691.691 0 00-.198.485v6.862c0 .183.072.357.199.486s.299.2.478.2h1.355v1.373h6.77v-1.372h1.355c.18 0 .351-.072.478-.201a.691.691 0 00.199-.486V4.912a.69.69 0 00-.199-.486z"
	        clipRule="evenodd"
	      ></path>
	    </svg>
	   );
  };
}



export class MinifigIconColor extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg className={"icon minifig-icon--color " + classes} viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
				<defs>
					<path d="M6,20 L5,20 C3.34314575,20 2,18.6568542 2,17 L2,8 C2,6.34314575 3.34314575,5 5,5 L7,5 L7,3 C7,2.44771525 7.44771525,2 8,2 L16,2 C16.5522847,2 17,2.44771525 17,3 L17,5 L19,5 C20.6568542,5 22,6.34314575 22,8 L22,17 C22,18.6568542 20.6568542,20 19,20 L18,20 L18,22 L6,22 L6,20 Z" id="path-1-minifig"></path>
					<filter x="-5.0%" y="-5.0%" width="110.0%" height="110.0%" filterUnits="objectBoundingBox" id="filter-2-minifig">
						<feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetInner1"></feOffset>
						<feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
						<feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
					</filter>
				</defs>
				<g id="nav" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="xp1_nav" transform="translate(-26.000000, -231.000000)">
						<g id="catalog" transform="translate(24.000000, 110.000000)">
							<g id="Icon/Nav/Minifig" transform="translate(0.000000, 119.000000)">
								<g id="minifigs">
									<use fill="#F7D118" fillRule="evenodd" xlinkHref="#path-1-minifig"></use>
									<use fill="black" fillOpacity="1" filter="url(#filter-2-minifig)" xlinkHref="#path-1-minifig"></use>
									<path stroke="#CEAD06" strokeWidth="1" d="M6.5,21.5 L17.5,21.5 L17.5,19.5 L19,19.5 C20.3807119,19.5 21.5,18.3807119 21.5,17 L21.5,8 C21.5,6.61928813 20.3807119,5.5 19,5.5 L16.5,5.5 L16.5,3 C16.5,2.72385763 16.2761424,2.5 16,2.5 L8,2.5 C7.72385763,2.5 7.5,2.72385763 7.5,3 L7.5,5.5 L5,5.5 C3.61928813,5.5 2.5,6.61928813 2.5,8 L2.5,17 C2.5,18.3807119 3.61928813,19.5 5,19.5 L6.5,19.5 L6.5,21.5 Z" strokeLinejoin="square"></path>
								</g>
								<circle id="Combined-Shape" fill="#111111" fillRule="evenodd" cx="10" cy="11" r="1"></circle>
								<circle id="Combined-Shape" fill="#111111" fillRule="evenodd" cx="14" cy="11" r="1"></circle>
								<path d="M9,15 C10,15.4086022 11,15.6129032 12,15.6129032 C13,15.6129032 14,15.4086022 15,15" id="Path-2" stroke="#111111" strokeWidth="1" strokeLinecap="round" fillRule="nonzero"></path>
							</g>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}

export class PartIcon extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg className={"icon part-icon " + classes} viewBox="0 0 16 9" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<path id="parts" d="M4,3l0,-2c0,-0.552 0.448,-1 1,-1l6,0c0.552,0 1,0.448 1,1l0,2l3,0c0.552,0 1,0.448 1,1l0,4c0,0.552 -0.448,1 -1,1l-14,0c-0.552,0 -1,-0.448 -1,-1l0,-4c0,-0.552 0.448,-1 1,-1l3,0Z"/>
			</svg>
		);
	}
}

export class PartIconColor extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg className={"icon part-icon--color " + classes} viewBox="0 0 20 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
				<defs>
					<rect id="path-1-part" x="6" y="7" width="12" height="8" rx="1"></rect>
					<filter x="-8.3%" y="-12.5%" width="116.7%" height="125.0%" filterUnits="objectBoundingBox" id="filter-2">
						<feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetInner1"></feOffset>
						<feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
						<feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.24 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
					</filter>
					<rect id="path-3-part" x="2" y="11" width="20" height="6" rx="1"></rect>
					<filter x="-5.0%" y="-16.7%" width="110.0%" height="133.3%" filterUnits="objectBoundingBox" id="filter-4">
						<feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetInner1"></feOffset>
						<feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
						<feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.24 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
					</filter>
				</defs>
				<g id="nav" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="xp1_nav" transform="translate(-26.000000, -192.000000)" fillRule="nonzero">
						<g id="catalog" transform="translate(24.000000, 110.000000)">
							<g id="Icon/Nav/Parts" transform="translate(0.000000, 75.000000)">
								<g id="Rectangle-Copy">
									<use fill="#0788CA" xlinkHref="#path-1-part"></use>
									<use fill="black" fillOpacity="1" filter="url(#filter-2)" xlinkHref="#path-1-part"></use>
									<rect stroke="#045D8A" strokeWidth="1" strokeLinejoin="square" x="6.5" y="7.5" width="11" height="7" rx="1"></rect>
								</g>
								<g id="Rectangle">
									<use fill="#0788CA" xlinkHref="#path-3-part"></use>
									<use fill="black" fillOpacity="1" filter="url(#filter-4)" xlinkHref="#path-3-part"></use>
									<rect stroke="#045D8A" strokeWidth="1" strokeLinejoin="square" x="2.5" y="11.5" width="19" height="5" rx="1"></rect>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}

export class CollectionsIcon extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg className={"icon collections-logo " + classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
				<path d="M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"/>
			</svg>
		);
	}
}

export class CollectionsIconColor extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg className={"icon collections-logo--color " + classes} viewBox="0 0 20 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
				<g id="nav" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="xp1_nav" transform="translate(-26.000000, -278.000000)" fillRule="nonzero">
						<g id="catalog" transform="translate(24.000000, 110.000000)">
							<g id="Icon/Nav/Collections" transform="translate(0.000000, 163.000000)">
								<path d="M4,8 L15,8 C16.1045695,8 17,8.8954305 17,10 L17,18 C17,19.1045695 16.1045695,20 15,20 L4,20 C2.8954305,20 2,19.1045695 2,18 L2,10 C2,8.8954305 2.8954305,8 4,8 Z M3.5,9 C3.22385763,9 3,9.22385763 3,9.5 L3,18.5 C3,18.7761424 3.22385763,19 3.5,19 C3.77614237,19 4,18.7761424 4,18.5 L4,9.5 C4,9.22385763 3.77614237,9 3.5,9 Z" id="Rectangle-2" fill="#0A871F"></path>
								<path d="M4.5,19.5 L20,19.5 C20.8284271,19.5 21.5,18.8284271 21.5,18 L21.5,7 C21.5,6.17157288 20.8284271,5.5 20,5.5 L6,5.5 C5.17157288,5.5 4.5,6.17157288 4.5,7 L4.5,19.5 Z" id="Rectangle" stroke="#0A871F" strokeWidth="1" fill="#0FD430"></path>
								<path d="M7,8 L14,8 L14,15 L7,15 L7,8 Z M7,16 L14,16 L14,17 L7,17 L7,16 Z M15,8 L19,8 L19,10 L15,10 L15,8 Z M15,13 L19,13 L19,15 L15,15 L15,13 Z M15,16 L19,16 L19,17 L15,17 L15,16 Z M15,11 L19,11 L19,12 L15,12 L15,11 Z" id="Combined-Shape" fill="#0A871F"></path>
								<rect id="Rectangle" fill="#0FD430" x="3" y="9" width="1" height="10" rx="0.5"></rect>
							</g>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}

export class WantedHeart extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg className={"wanted-logo icon " + classes} viewBox="0 0 23 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<defs>
					<path d="M11.5,15 L11.5,12 L12.5,12 L12.5,15 L15.7653234,15 L18.1287879,12.6818182 C18.3403073,12.4726232 18.5511928,12.2439349 18.7528539,12 L16,12 L15,12 L9,12 L8,12 L5.23673473,12 C5.43793061,12.2423141 5.64849104,12.4655082 5.85984848,12.6628788 L8.23954288,15 L11.5,15 Z M12.5,16 L11.5,16 L9.25775897,16 L12,18.6931818 L14.7457897,16 L12.5,16 Z M15,11 L15,8 L16,8 L16,11 L19.4622459,11 C19.8909212,10.2791843 20.1818182,9.49132715 20.1818182,8.71212121 C20.1818182,8.46337466 20.1678761,8.22594241 20.1403715,8 L3.85952971,8 C3.83208745,8.22594241 3.81818182,8.46337466 3.81818182,8.71212121 C3.81818182,9.46775481 4.10746291,10.2699767 4.53420947,11 L8,11 L8,8 L9,8 L9,11 L15,11 Z M4.0953471,7 L11.594862,7 C10.7693245,6.17729176 9.27667102,4.81818182 7.75757576,4.81818182 C5.90035876,4.81818182 4.62605403,5.57093542 4.0953471,7 Z M12.4082065,7 L19.9040989,7 C19.3725031,5.57093542 18.096823,4.81818182 16.2424242,4.81818182 C14.7325167,4.81818182 13.2658347,6.1500694 12.4082065,7 Z M10.8371212,20.0984848 L4.59469697,13.969697 C4.32575758,13.719697 2,11.4886364 2,8.71212121 C2,5.27651515 4.15151515,3 7.75757576,3 C9.32575758,3 10.8106061,3.86363636 12,4.88636364 C13.1856061,3.86363636 14.6742424,3 16.2424242,3 C19.7159091,3 22,5.14015152 22,8.71212121 C22,10.6818182 20.7954545,12.6325758 19.4204545,13.9659091 L19.405303,13.9810606 L13.1628788,20.0984848 C12.5182189,20.7348566 11.4817811,20.7348566 10.8371212,20.0984848 Z" id="path-1"></path>
				</defs>
				<g id="icons" style={{stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd"}}>
					<g id="wanted-logo__icon" style={{transform: "translate(-2.000000, -3.000000)"}}>
						<mask id="mask-2" style={{fill: "white"}}>
							<use xlinkHref="#path-1"></use>
						</mask>
						<use id="Mask" style={{fillRule: "nonzero"}} xlinkHref="#path-1"></use>
					</g>
				</g>
			</svg>
		);
	}
}

export class ColorWheel extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg className={"color-wheel icon " + classes} viewBox="0 0 23 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<clipPath id="colorWheel" >
					<path d="M11,21.5c-5.799,0 -10.5,-4.701 -10.5,-10.5c0,-5.799 4.701,-10.5 10.5,-10.5c5.799,0 10.5,4.701 10.5,10.5c0,5.799 -4.701,10.5 -10.5,10.5Zm0,-6c2.485,0 4.5,-2.015 4.5,-4.5c0,-2.485 -2.015,-4.5 -4.5,-4.5c-2.485,0 -4.5,2.015 -4.5,4.5c0,2.485 2.015,4.5 4.5,4.5Z"/>
				</clipPath>
				<g clipPath="url(#colorWheel)">
					<path id="Rectangle" d="M21.5,22.207l-11.707,-11.707l11.707,0l0,11.707Z" style={{fill: "#46c7e0", fillRule: "nonzero", stroke: "#fff", strokeWidth: "1px"}}/>
					<path id="Rectangle1" d="M0.5,22.207l11.707,-11.707l-11.707,0l0,11.707Z" style={{fill: "#9b4082", fillRule: "nonzero", stroke: "#fff", strokeWidth: "1px"}}/>
					<path id="Rectangle2" d="M11.5,9.793l-11.707,11.707l11.707,0l0,-11.707Z" style={{fill: "#473c9a", fillRule: "nonzero", stroke: "#fff", strokeWidth: "1px"}}/>
					<path id="Rectangle3" d="M10.5,9.793l11.707,11.707l-11.707,0l0,-11.707Z" style={{fill: "#035ec5", fillRule: "nonzero", stroke: "#fff", strokeWidth: "1px"}}/>
					<path id="Rectangle4" d="M0.5,-0.207l11.707,11.707l-11.707,0l0,-11.707Z" style={{fill: "#d80000", fillRule: "nonzero", stroke: "#fff", strokeWidth: "1px"}}/>
					<path id="Rectangle5" d="M21.5,-0.207l-11.707,11.707l11.707,0l0,-11.707Z" style={{fill: "#0a871f", fillRule: "nonzero", stroke: "#fff", strokeWidth: "1px"}}/>
					<path id="Rectangle6" d="M10.5,12.207l11.707,-11.707l-11.707,0l0,11.707Z" style={{fill: "#f1d23d", fillRule: "nonzero", stroke: "#fff", strokeWidth: "1px"}}/>
					<path id="Rectangle7" d="M11.5,12.207l-11.707,-11.707l11.707,0l0,11.707Z" style={{fill: "#fb9317", fillRule: "nonzero", stroke: "#fff", strokeWidth: "1px"}}/>
				</g>
				<path d="M11,21.5c-5.799,0 -10.5,-4.701 -10.5,-10.5c0,-5.799 4.701,-10.5 10.5,-10.5c5.799,0 10.5,4.701 10.5,10.5c0,5.799 -4.701,10.5 -10.5,10.5Zm0,-6c2.485,0 4.5,-2.015 4.5,-4.5c0,-2.485 -2.015,-4.5 -4.5,-4.5c-2.485,0 -4.5,2.015 -4.5,4.5c0,2.485 2.015,4.5 4.5,4.5Z" style={{fill: "none", stroke: "#fff", strokeWidth: "1px"}}/>
			</svg>
		);
	}
}

export class BrowseIcon extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg className={"browse-icon icon " + classes} viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" >
				<path d="M3,6c-1.657,0 -3,-1.343 -3,-3c0,-1.657 1.343,-3 3,-3c1.657,0 3,1.343 3,3c0,1.657 -1.343,3 -3,3Zm0,8c-1.657,0 -3,-1.343 -3,-3c0,-1.657 1.343,-3 3,-3c1.657,0 3,1.343 3,3c0,1.657 -1.343,3 -3,3Zm8,-8c-1.657,0 -3,-1.343 -3,-3c0,-1.657 1.343,-3 3,-3c1.657,0 3,1.343 3,3c0,1.657 -1.343,3 -3,3Zm0,8c-1.657,0 -3,-1.343 -3,-3c0,-1.657 1.343,-3 3,-3c1.657,0 3,1.343 3,3c0,1.657 -1.343,3 -3,3Z"/>
			</svg>
		);
	}
}

export class GalleryIcon extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg className={"gallery-icon icon " + classes} viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<g id="Gallery-Grid" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Gallery-Filtered" transform="translate(-202.000000, -149.000000)">
						<g id="Header" transform="translate(0.000000, 119.000000)">
							<g id="My-Gallery-button" transform="translate(194.000000, 24.000000)">
								<g id="Button/Xsmall/GhostLeft">
									<g id="Group-3" transform="translate(8.000000, 6.000000)">
										<g id="Group">
											<rect id="Container" opacity="0.435267857" x="0" y="0" width="20" height="20"></rect>
											<path d="M5.78595494,2.00585441 L5.56351221,2.89802347 L1.1761073,3.7508486 L3.00499667,13.1596688 L2.54990058,14.9849595 C2.5420593,15.0164092 2.53516804,15.047873 2.52920863,15.0793207 L0.358084645,3.90985609 C0.27026723,3.45807466 0.565318366,3.02064336 1.0170998,2.93282594 L5.78595494,2.00585441 Z M9.11016157,18.3383057 L4.19724972,19.293279 C3.74546829,19.3810964 3.30803699,19.0860453 3.22021958,18.6342638 L2.76414192,16.2879477 C2.98355097,16.6301804 3.32783656,16.8933015 3.75192899,17.0023024 L4.03824223,18.4752563 L7.19689883,17.8612757 L9.11016157,18.3383057 Z M5.34106947,3.79019254 L3.48202665,11.246406 L2.15313745,4.40986375 L5.34106947,3.79019254 Z" id="Shape" fill="#0688CA" fillRule="nonzero"></path>
											<path d="M7.99729341,0.02495029 L19.3174102,2.84737241 C19.7639765,2.95871388 20.0357299,3.41098748 19.9243884,3.85755376 L16.29556,18.4119897 C16.1842185,18.8585559 15.7319449,19.1303093 15.2853786,19.0189678 L3.96526182,16.1965457 C3.51869554,16.0852042 3.24694215,15.6329307 3.35828362,15.1863644 L6.98711206,0.631928482 C7.09845354,0.185362205 7.55072713,-0.086391188 7.99729341,0.02495029 Z M7.79569183,0.833530062 L4.1668634,15.387966 L15.4869802,18.2103881 L19.1158086,3.65595218 L7.79569183,0.833530062 Z M8.40267002,1.84371141 L18.1056273,4.26293037 L15.4848067,14.7744674 L5.78184949,12.3552484 L8.40267002,1.84371141 Z" id="Shape" fill="#0688CA" fillRule="nonzero"></path>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}

export class CurrencyEstimate extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg className={"currency-estimate-icon icon " + classes} viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<defs>
					<path d="M28.2029906,6.79700941 L25.7489919,9.25100806 C23.6379368,7.13957661 20.7217406,5.83333333 17.5,5.83333333 C11.2540054,5.83333333 6.15435484,10.741707 5.84791667,16.9116331 C5.83196909,17.2323723 6.09089382,17.5 6.41200941,17.5 L7.73133065,17.5 C8.03019489,17.5 8.27764113,17.267043 8.29457661,16.9686962 C8.56940188,12.1205847 12.5817944,8.27956989 17.5,8.27956989 C20.0479906,8.27956989 22.3528159,9.31089382 24.0208199,10.9791801 L21.4744758,13.5255712 C21.1188306,13.8812164 21.3706989,14.4892473 21.8736358,14.4892473 L28.6021505,14.4892473 C28.9139046,14.4892473 29.1666667,14.2364852 29.1666667,13.9247312 L29.1666667,7.1962164 C29.1666667,6.69327957 28.5585887,6.44141129 28.2029906,6.79700941 Z M28.5879906,17.5 L27.2686694,17.5 C26.9698051,17.5 26.7223589,17.732957 26.7054234,18.0313038 C26.4305981,22.8794153 22.4182056,26.7204301 17.5,26.7204301 C14.9520094,26.7204301 12.6471841,25.6891062 10.9791801,24.0208199 L13.5255242,21.4744288 C13.8811694,21.1187836 13.6293011,20.5107527 13.1263642,20.5107527 L6.39784946,20.5107527 C6.08609543,20.5107527 5.83333333,20.7635148 5.83333333,21.0752688 L5.83333333,27.8037836 C5.83333333,28.3067204 6.44141129,28.5585887 6.79700941,28.2029435 L9.25100806,25.7489919 C11.3620632,27.8604234 14.2783065,29.1666667 17.5,29.1666667 C23.7460417,29.1666667 28.8456452,24.258293 29.1520833,18.0883669 C29.1680309,17.7676277 28.9091062,17.5 28.5879906,17.5 Z" id="path-1-currency"></path>
					<path d="M7.77733355,6.19530011 C8.25910334,6.58592418 8.49998808,7.07420427 8.49998808,7.66014037 C8.49998808,8.24607647 8.31118635,8.74086686 7.93358318,9.14451183 C7.58202152,9.5090944 7.13280384,9.74346884 6.58593014,9.84763516 L6.58593014,10.7656017 C6.58593014,10.8307056 6.56314364,10.8860442 6.51757093,10.9316169 C6.47199822,10.9771897 6.41665961,10.9999762 6.3515557,10.9999762 L5.7656196,10.9999762 C5.70051569,10.9999762 5.64517708,10.9771897 5.59960437,10.9316169 C5.55403166,10.8860442 5.53124516,10.8307056 5.53124516,10.7656017 L5.53124516,9.84763516 C5.01041297,9.76951034 4.52864348,9.58721921 4.0859361,9.30076146 C3.86458256,9.15753273 3.68880173,9.01430371 3.55859361,8.87107498 C3.5195312,8.83201258 3.5,8.78318457 3.5,8.72459096 C3.5,8.66599735 3.5195312,8.61065904 3.55859361,8.55857573 L3.96874888,8.03123324 C4.02083219,7.97914993 4.0826808,7.94985312 4.15429532,7.94334282 C4.22590983,7.93683252 4.28124814,7.95961872 4.32031054,8.01170203 C4.45051867,8.14191015 4.6197889,8.26560768 4.82812183,8.3827949 C5.2317668,8.63019024 5.64843238,8.75388776 6.07811885,8.75388776 C6.40363901,8.75388776 6.68358616,8.66925265 6.9179606,8.49998212 C7.17837655,8.30467008 7.30858467,8.03774354 7.30858467,7.69920278 C7.30858467,7.45180743 7.17837655,7.2304539 6.9179606,7.03514186 C6.72264857,6.90493374 6.3645766,6.72915291 5.84374441,6.50779937 C5.49218275,6.37759125 5.2317668,6.27342493 5.06249627,6.19530011 C4.78905943,6.05207139 4.56119529,5.90884236 4.37890415,5.76561364 C3.87109287,5.36196867 3.61718722,4.84764708 3.61718722,4.22264857 C3.61718722,3.68879577 3.81900956,3.22655719 4.22265453,2.83593312 C4.56119529,2.51041297 4.99739236,2.29556973 5.53124516,2.19140341 L5.53124516,1.23437444 C5.53124516,1.16927053 5.55403166,1.11393192 5.59960437,1.06835921 C5.64517708,1.0227865 5.70051569,1 5.7656196,1 L6.3515557,1 C6.41665961,1 6.47199822,1.0227865 6.51757093,1.06835921 C6.56314364,1.11393192 6.58593014,1.16927053 6.58593014,1.23437444 L6.58593014,2.152341 C7.02863752,2.20442431 7.43879279,2.34114274 7.81639596,2.56249627 C7.99868709,2.6796835 8.14842642,2.79687072 8.26561364,2.91405794 C8.29165514,2.94009944 8.30793134,2.98241715 8.31444165,3.04101076 C8.32095195,3.09960437 8.31118635,3.14843238 8.28514484,3.18749478 L7.95311438,3.77343089 C7.91405198,3.8255142 7.85871367,3.858066 7.78709915,3.8710869 C7.71548464,3.88410781 7.64712543,3.8645766 7.58202152,3.81249329 C7.4908758,3.72134758 7.35415738,3.63020216 7.17186625,3.53905645 C6.83332549,3.35676531 6.48827413,3.2656196 6.13671246,3.2656196 C5.73306749,3.2656196 5.40754763,3.36327562 5.16015229,3.55858765 C4.93879875,3.72785818 4.82812183,3.94921172 4.82812183,4.22264857 C4.82812183,4.49608541 4.96484026,4.73045986 5.23827711,4.92577189 C5.43358914,5.06900062 5.80468201,5.25129205 6.3515557,5.47264559 C6.69009646,5.61587431 6.9374918,5.72004093 7.09374143,5.78514484 C7.36717828,5.91535296 7.59504242,6.05207139 7.77733355,6.19530011 Z" id="path-3-currency"></path>
				</defs>
				<g id="Mobile" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Project-Page" transform="translate(-112.000000, -580.000000)">
						<g id="Content" transform="translate(0.000000, 119.000000)">
							<g id="Stats-&amp;-Tags" transform="translate(12.000000, 453.000000)">
								<g id="Easy-Buy-button">
									<g id="Group-6" transform="translate(95.000000, 3.000000)">
										<g id="Icon/Sync">
											<mask id="mask-2-currency" fill="white">
												<use xlinkHref="#path-1-currency"></use>
											</mask>
											<use id="Mask" fill="#FFFFFF" fillRule="nonzero" xlinkHref="#path-1-currency"></use>
											<g id="Mixin/Fill/Black" mask="url(#mask-2-currency)" fill="#0A1E32" fillRule="evenodd">
												<rect id="Black" x="0" y="0" width="35" height="35"></rect>
											</g>
										</g>
										<g id="Icon/Currency/USD" transform="translate(12.000000, 12.000000)">
											<polygon id="Bounding-Box" points="0 0 12 0 12 12 0 12"></polygon>
											<mask id="mask-4-currency" fill="white">
												<use xlinkHref="#path-3-currency"></use>
											</mask>
											<use id="Mask" fill="#0A1E32" fillRule="evenodd" xlinkHref="#path-3-currency"></use>
											<g id="Mixin/Fill/Black" mask="url(#mask-4-currency)" fill="#0A1E32" fillRule="evenodd">
												<rect id="Black" x="0" y="0" width="12" height="12"></rect>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}

export class AwardIcon extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = '', award, background, showTooltip = true, source = false, tooltipClass = ''} = this.props;
		if( !award || award == 0 ) return null;

		const selectedAward = award.strWebSlug ? award : Number.isInteger(award) ? StudioAwards(award) : award;

		if(selectedAward) {
			const tooltipContent = selectedAward && selectedAward.noIntroTooltip ? selectedAward.content : selectedAward.intro + ' ' + selectedAward.content;
			const bgColor = selectedAward && selectedAward.strIconsConfig ? JSON.parse(selectedAward.strIconsConfig).bgColor : '';
			const iconColor = selectedAward && selectedAward.strIconsConfig ? JSON.parse(selectedAward.strIconsConfig).iconColor : '';

			return (
				<div style={{backgroundColor: bgColor}} data-ts-name="award-icon" className={`award-icon award-icon--${selectedAward.strWebSlug ? selectedAward.strWebSlug : selectedAward.slug} ${selectedAward.type ? `award-icon--type-${selectedAward.type}` : ''} ${classes} ${background ? ' award-icon--with-background' : ''}${!showTooltip ? ' l-cursor-auto' : ''} js-bottom-right-tooltip`} data-tooltip={tooltipContent} data-tooltip-classname={tooltipClass ? tooltipClass : source == 'card' ? 'award-icon-tooltip--card' : ''} data-tooltip-width={selectedAward.noIntroTooltip ? 150 : 200} onMouseOver={showTooltip ? (e) => HoverShowTooltip(e) : null} onMouseLeave={showTooltip ? (e) => HoverHideTooltip(e) : null}>
					<i style={{color: iconColor == 'dark' ? '#111111' : '#ffffff'}} className={`award-icon__icon ${selectedAward.icon}`}/>
				</div>
			);
		}else{
			return false;
		}
	}
}

export class DoesntShipIcon extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;
		
		return (
			<svg className={`doesnt-ship-icon icon ${classes}`} viewBox="0 0 21 19" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<g transform="matrix(1,0,0,1,-0.514719,-0.514719)">
					<g id="truck-slash" transform="matrix(1,0,0,1,-2,-2)">
						<path d="M4.222,2.808L21.192,19.778C21.583,20.169 21.583,20.802 21.192,21.192C20.802,21.583 20.169,21.583 19.778,21.192L2.808,4.222C2.417,3.831 2.417,3.198 2.808,2.808C3.198,2.417 3.831,2.417 4.222,2.808ZM3,5.828L4.519,7.347L4.519,15.646L5.437,15.646C5.711,15.181 6.08,14.812 6.544,14.538C7.008,14.264 7.515,14.127 8.063,14.127C8.612,14.127 9.118,14.264 9.582,14.538C10.046,14.812 10.416,15.181 10.69,15.646L12.817,15.645L14.336,17.164L11.101,17.165C11.101,17.932 10.857,18.594 10.369,19.152L10.215,19.316C9.624,19.907 8.907,20.203 8.063,20.203C7.219,20.203 6.502,19.907 5.911,19.316C5.321,18.726 5.025,18.008 5.025,17.165L4.519,17.165C4.097,17.165 3.738,17.017 3.443,16.722C3.148,16.426 3,16.068 3,15.646L3,5.828ZM15.297,18.128L17.227,20.057C16.786,19.915 16.389,19.668 16.038,19.316C15.687,18.965 15.44,18.569 15.297,18.128ZM8.063,15.646C7.641,15.646 7.283,15.793 6.987,16.089C6.692,16.384 6.544,16.743 6.544,17.165C6.544,17.586 6.692,17.945 6.987,18.241C7.283,18.536 7.641,18.684 8.063,18.684C8.485,18.684 8.844,18.536 9.139,18.241C9.435,17.945 9.582,17.586 9.582,17.165C9.582,16.743 9.435,16.384 9.139,16.089C8.844,15.793 8.485,15.646 8.063,15.646ZM14.646,4C15.068,4 15.426,4.148 15.722,4.443C16.017,4.738 16.165,5.097 16.165,5.519L16.165,7.038L17.557,7.038C17.979,7.038 18.338,7.186 18.633,7.481L21.797,10.646C22.093,10.941 22.241,11.3 22.241,11.722L22.241,15.646L22.62,15.646C22.726,15.646 22.815,15.682 22.889,15.756C22.963,15.83 23,15.92 23,16.025L23,16.785C23,16.89 22.963,16.98 22.889,17.054C22.815,17.128 22.726,17.165 22.62,17.165L21.228,17.165C21.228,17.542 21.169,17.895 21.05,18.222L19.679,16.851C19.623,16.562 19.485,16.308 19.266,16.089C19.047,15.869 18.793,15.732 18.504,15.675L17.133,14.304C17.46,14.186 17.813,14.127 18.19,14.127C18.717,14.127 19.203,14.248 19.646,14.491C20.089,14.733 20.447,15.065 20.722,15.487L20.722,11.722L17.557,8.557L16.165,8.557L16.164,13.336L14.645,11.817L14.646,5.519L8.347,5.519L6.828,4L14.646,4ZM17.177,9.57L19.709,12.101L17.177,12.101L17.177,9.57Z" style={{fill: "rgb(216,0,0)"}}/>
					</g>
				</g>
		</svg>

		);
	}
}

export class StudioUploadIcon extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 84 96"
				className={`studio-upload-icon icon ${classes}`}
			>
				<path
					fill="#fff"
					d="M16.246 0C10.128 0 5.17 4.959 5.17 11.077v66.462c0 6.11 4.959 11.076 11.077 11.076h44.308c6.11 0 11.077-4.967 11.077-11.076V31.136a8.348 8.348 0 00-2.44-5.884L46.378 2.433A8.34 8.34 0 0040.494 0H16.246z"
				></path>
				<path
					fill="url(#paint0_linear_483_13110)"
					fillRule="evenodd"
					d="M43.734 37.814l14.952 14.952a7.048 7.048 0 010 9.968L43.734 77.686a7.048 7.048 0 01-9.968 0L18.814 62.734a7.048 7.048 0 010-9.968l14.952-14.952a7.048 7.048 0 019.968 0z"
					clipRule="evenodd"
				></path>
				<g
					fillRule="evenodd"
					clipRule="evenodd"
					filter="url(#filter0_i_483_13110)"
				>
					<path
						fill="#2C2E35"
						d="M43.09 39.266L57.234 53.41a6.137 6.137 0 010 8.68L43.09 76.234a6.137 6.137 0 01-8.68 0L20.266 62.09a6.137 6.137 0 010-8.68L34.41 39.266a6.137 6.137 0 018.68 0z"
					></path>
					<path
						fill="url(#paint1_linear_483_13110)"
						d="M43.09 39.266L57.234 53.41a6.137 6.137 0 010 8.68L43.09 76.234a6.137 6.137 0 01-8.68 0L20.266 62.09a6.137 6.137 0 010-8.68L34.41 39.266a6.137 6.137 0 018.68 0z"
						style={{ mixBlendMode: "soft-light" }}
					></path>
				</g>
				<g filter="url(#filter1_d_483_13110)">
					<circle cx="27.063" cy="57.75" r="5.844" fill="#72C850"></circle>
				</g>
				<g filter="url(#filter2_d_483_13110)">
					<ellipse
						cx="50.438"
						cy="57.75"
						fill="#F45C40"
						rx="5.844"
						ry="5.844"
					></ellipse>
				</g>
				<g filter="url(#filter3_d_483_13110)">
					<ellipse
						cx="38.75"
						cy="69.438"
						fill="#F7D117"
						rx="5.844"
						ry="5.844"
					></ellipse>
				</g>
				<g filter="url(#filter4_d_483_13110)">
					<circle cx="38.75" cy="46.063" r="5.844" fill="#42C0FB"></circle>
				</g>
				<rect
					width="35.446"
					height="17.723"
					y="11.815"
					fill="#F2B90B"
					rx="2.954"
				></rect>
				<path
					fill="#2C2E35"
					d="M12.19 16.415v1.31h1.598v5.787H12.19v1.303h4.858v-1.303H15.41v-5.787h1.638v-1.31H12.19zm12.6 4.818V20.01c0-.381-.036-.74-.11-1.08a4.104 4.104 0 00-.305-.934 3.447 3.447 0 00-.444-.686 2.528 2.528 0 00-.595-.531 2.643 2.643 0 00-.767-.352 3.125 3.125 0 00-.906-.127c-.319 0-.615.04-.888.121a2.609 2.609 0 00-1.333.9 3.45 3.45 0 00-.432.721c-.123.281-.218.587-.283.918a5.74 5.74 0 00-.092 1.05v1.223c0 .346.026.675.08.986.058.312.14.6.248.866.12.288.268.548.445.778.177.227.377.422.6.583.227.154.479.273.755.358.277.084.58.127.906.127.308 0 .594-.039.86-.116.27-.073.515-.177.738-.311a2.75 2.75 0 00.658-.577c.192-.23.354-.485.485-.762a4.32 4.32 0 00.282-.9c.066-.327.098-.67.098-1.032zm-1.644-1.235v1.235c0 .207-.011.407-.035.6-.019.192-.05.369-.092.53a2.356 2.356 0 01-.219.56 1.366 1.366 0 01-.329.404 1.089 1.089 0 01-.358.202 1.36 1.36 0 01-.444.07c-.169 0-.32-.026-.456-.076a1.137 1.137 0 01-.352-.213 1.443 1.443 0 01-.294-.404 2.45 2.45 0 01-.184-.56 3.493 3.493 0 01-.081-.525 7.228 7.228 0 01-.023-.588v-1.235c0-.215.008-.421.023-.617.02-.196.048-.377.086-.543.05-.215.12-.403.208-.565.092-.162.204-.296.335-.404.096-.073.204-.129.323-.167.123-.039.26-.058.41-.058.157 0 .3.021.426.064.131.042.248.102.352.179.131.103.244.238.34.403.097.162.174.347.231.554.047.166.08.346.098.543.024.192.035.396.035.611z"
				></path>
				<circle cx="70.154" cy="82.708" r="13.292" fill="#07B018"></circle>
				<path
					fill="#fff"
					d="M66.876 82.382a1.108 1.108 0 01-1.566-1.564l4.43-4.432c.215-.216.5-.325.783-.325.284 0 .568.109.783.327l4.431 4.43a1.108 1.108 0 01-1.566 1.567l-2.54-2.54v8.401a1.108 1.108 0 01-2.216 0v-8.401l-2.539 2.537z"
				></path>
				<path
					fill="#2C2E35"
					fillOpacity="0.08"
					d="M67.667 27.692a3.726 3.726 0 00-.432-.467L44.405 4.391c-.138-.15-.45-.293-.467-.422v19.57a4.144 4.144 0 004.154 4.153h19.575z"
				></path>
				<defs>
					<filter
						id="filter0_i_483_13110"
						width="40.563"
						height="40.563"
						x="18.469"
						y="37.469"
						colorInterpolationFilters="sRGB"
						filterUnits="userSpaceOnUse"
					>
						<feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
						<feBlend
							in="SourceGraphic"
							in2="BackgroundImageFix"
							result="shape"
						></feBlend>
						<feColorMatrix
							in="SourceAlpha"
							result="hardAlpha"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						></feColorMatrix>
						<feOffset></feOffset>
						<feGaussianBlur stdDeviation="0.401"></feGaussianBlur>
						<feComposite
							in2="hardAlpha"
							k2="-1"
							k3="1"
							operator="arithmetic"
						></feComposite>
						<feColorMatrix values="0 0 0 0 0.138755 0 0 0 0 0.164163 0 0 0 0 0.251276 0 0 0 0.5 0"></feColorMatrix>
						<feBlend in2="shape" result="effect1_innerShadow_483_13110"></feBlend>
					</filter>
					<filter
						id="filter1_d_483_13110"
						width="11.688"
						height="14.688"
						x="21.219"
						y="51.906"
						colorInterpolationFilters="sRGB"
						filterUnits="userSpaceOnUse"
					>
						<feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
						<feColorMatrix
							in="SourceAlpha"
							result="hardAlpha"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						></feColorMatrix>
						<feOffset dy="3"></feOffset>
						<feColorMatrix values="0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.14902 0 0 0 1 0"></feColorMatrix>
						<feBlend
							in2="BackgroundImageFix"
							result="effect1_dropShadow_483_13110"
						></feBlend>
						<feBlend
							in="SourceGraphic"
							in2="effect1_dropShadow_483_13110"
							result="shape"
						></feBlend>
					</filter>
					<filter
						id="filter2_d_483_13110"
						width="11.688"
						height="14.688"
						x="44.594"
						y="51.906"
						colorInterpolationFilters="sRGB"
						filterUnits="userSpaceOnUse"
					>
						<feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
						<feColorMatrix
							in="SourceAlpha"
							result="hardAlpha"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						></feColorMatrix>
						<feOffset dy="3"></feOffset>
						<feColorMatrix values="0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.14902 0 0 0 1 0"></feColorMatrix>
						<feBlend
							in2="BackgroundImageFix"
							result="effect1_dropShadow_483_13110"
						></feBlend>
						<feBlend
							in="SourceGraphic"
							in2="effect1_dropShadow_483_13110"
							result="shape"
						></feBlend>
					</filter>
					<filter
						id="filter3_d_483_13110"
						width="11.688"
						height="14.688"
						x="32.906"
						y="63.594"
						colorInterpolationFilters="sRGB"
						filterUnits="userSpaceOnUse"
					>
						<feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
						<feColorMatrix
							in="SourceAlpha"
							result="hardAlpha"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						></feColorMatrix>
						<feOffset dy="3"></feOffset>
						<feColorMatrix values="0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.14902 0 0 0 1 0"></feColorMatrix>
						<feBlend
							in2="BackgroundImageFix"
							result="effect1_dropShadow_483_13110"
						></feBlend>
						<feBlend
							in="SourceGraphic"
							in2="effect1_dropShadow_483_13110"
							result="shape"
						></feBlend>
					</filter>
					<filter
						id="filter4_d_483_13110"
						width="11.688"
						height="14.688"
						x="32.906"
						y="40.219"
						colorInterpolationFilters="sRGB"
						filterUnits="userSpaceOnUse"
					>
						<feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
						<feColorMatrix
							in="SourceAlpha"
							result="hardAlpha"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						></feColorMatrix>
						<feOffset dy="3"></feOffset>
						<feColorMatrix values="0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.14902 0 0 0 1 0"></feColorMatrix>
						<feBlend
							in2="BackgroundImageFix"
							result="effect1_dropShadow_483_13110"
						></feBlend>
						<feBlend
							in="SourceGraphic"
							in2="effect1_dropShadow_483_13110"
							result="shape"
						></feBlend>
					</filter>
					<linearGradient
						id="paint0_linear_483_13110"
						x1="16.75"
						x2="16.75"
						y1="35.75"
						y2="79.75"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#636A82"></stop>
						<stop offset="1" stopColor="#414554"></stop>
					</linearGradient>
					<linearGradient
						id="paint1_linear_483_13110"
						x1="1.716"
						x2="38.616"
						y1="58.586"
						y2="95.011"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#fff" stopOpacity="0.5"></stop>
						<stop offset="1" stopColor="#fff" stopOpacity="0.01"></stop>
					</linearGradient>
				</defs>
			</svg>
		);
	}
}

export class StudioUploadIconOutline extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = ''} = this.props;

		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 84 96"
				className={`studio-upload-icon studio-upload-icon--outline icon ${classes}`}
			>
				<g opacity="0.24">
					<path
						fill="#2C2E35"
						d="M5.17 11.077C5.17 4.959 10.127 0 16.245 0h24.248a8.34 8.34 0 015.885 2.433L69.19 25.252a8.348 8.348 0 012.44 5.885v46.401c0 6.11-4.966 11.077-11.076 11.077H16.246c-6.118 0-11.077-4.967-11.077-11.076V11.076zm63.692 66.462V31.136c0-.224-.018-.45-.035-.674H48.092a6.921 6.921 0 01-6.923-6.924V2.811a5.521 5.521 0 00-.675-.042H16.246a8.308 8.308 0 00-8.308 8.308v66.462a8.309 8.309 0 008.308 8.307h44.308a8.31 8.31 0 008.308-8.308zm-1.195-49.847a3.733 3.733 0 00-.432-.467L44.405 4.391c-.138-.15-.45-.293-.467-.422v19.57a4.144 4.144 0 004.154 4.153h19.575z"
					></path>
					<rect
						width="33.14"
						height="33.14"
						x="38.246"
						y="34.013"
						stroke="#2C2E35"
						strokeWidth="2.215"
						rx="4.8"
						transform="rotate(45 38.246 34.013)"
					></rect>
					<path
						stroke="#2C2E35"
						strokeWidth="2.215"
						d="M32.306 57.446a4.736 4.736 0 11-9.472 0 4.736 4.736 0 019.472 0zm21.352 0a4.736 4.736 0 11-9.472 0 4.736 4.736 0 019.472 0zM42.982 68.123a4.736 4.736 0 11-9.472 0 4.736 4.736 0 019.472 0zm0-21.353a4.736 4.736 0 11-9.472 0 4.736 4.736 0 019.472 0z"
					></path>
					<rect
						width="33.231"
						height="15.508"
						x="1.108"
						y="12.923"
						fill="#fff"
						stroke="#2C2E35"
						strokeWidth="2.215"
						rx="1.846"
					></rect>
					<path
						fill="#2C2E35"
						d="M12.19 16.415v1.31h1.598v5.787H12.19v1.303h4.858v-1.303H15.41v-5.787h1.638v-1.31H12.19zm12.6 4.818V20.01c0-.381-.036-.74-.11-1.08a4.103 4.103 0 00-.305-.934 3.447 3.447 0 00-.444-.686 2.526 2.526 0 00-.595-.531 2.638 2.638 0 00-.767-.352 3.125 3.125 0 00-.906-.127c-.319 0-.615.04-.888.121a2.609 2.609 0 00-1.333.9 3.45 3.45 0 00-.432.721 4.395 4.395 0 00-.283.918c-.062.33-.092.68-.092 1.05v1.223c0 .346.026.675.08.986.058.312.14.6.248.866.12.288.268.548.445.778.177.227.377.422.6.583.227.154.479.273.755.358.277.085.58.127.906.127.308 0 .594-.039.86-.116a2.88 2.88 0 00.738-.311c.246-.154.466-.346.658-.577a3.56 3.56 0 00.485-.762c.123-.276.217-.576.282-.9.066-.326.098-.67.098-1.032zm-1.644-1.235v1.235c0 .207-.011.407-.035.6a3.45 3.45 0 01-.092.53 2.355 2.355 0 01-.219.56 1.365 1.365 0 01-.329.404 1.092 1.092 0 01-.358.202 1.36 1.36 0 01-.444.07 1.31 1.31 0 01-.456-.076 1.137 1.137 0 01-.352-.213 1.443 1.443 0 01-.294-.404 2.449 2.449 0 01-.184-.56 3.493 3.493 0 01-.081-.525 7.23 7.23 0 01-.023-.588v-1.235c0-.215.008-.421.023-.617.02-.196.048-.377.086-.543.05-.215.12-.403.208-.565a1.45 1.45 0 01.335-.404c.096-.073.204-.129.323-.167.123-.039.26-.058.41-.058.157 0 .3.021.426.064.131.042.248.102.352.179a1.4 1.4 0 01.34.403c.097.162.174.347.231.554.047.166.08.346.098.543.024.192.035.396.035.611z"
					></path>
					<circle
						cx="70.154"
						cy="82.708"
						r="11.815"
						fill="#fff"
						stroke="#2C2E35"
						strokeWidth="2.954"
					></circle>
					<path
						fill="#2C2E35"
						d="M66.876 82.382a1.108 1.108 0 01-1.566-1.564l4.43-4.432a1.102 1.102 0 011.566.002l4.431 4.43a1.108 1.108 0 01-1.566 1.567l-2.54-2.54v8.401a1.108 1.108 0 01-2.216 0v-8.401l-2.539 2.537z"
					></path>
				</g>
			</svg>
		);
	}
}

export class SortTableHeaderIcon extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		const clickCallback = this.props.func.clickCallback;
		const {id, sortingType, sortingDirection, disabled, iconClass} = this.props.data;
		const sortingClass = (disabled)?"sorting-header-icon--disabled":(sortingDirection == "d")?"sorting-header-icon--down":(sortingDirection == "u")?"sorting-header-icon--up":"sorting-header-icon--disabled";
		
		return (
			<button id={id} className={"btn btn--blank " + iconClass} onClick={() => clickCallback(sortingType, sortingDirection) }>
				<i className={"fa-duotone fa-sort " + sortingClass} data-testid="sort-icon" />
			</button>
		);
	}
}

export class BDPIcon extends React.Component {
	render () {
		const {classes = ''} = this.props;

		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 13 13"
				className={`bdp-icon icon ${classes}`}
			>
				<path
					fill="#fff"
					fillRule="evenodd"
					d="M2.25 1A.75.75 0 013 .25h1.5a.75.75 0 01.75.75v.75H6a.75.75 0 01.75.75v3h.75v-.75A.75.75 0 018.25 4h2.25a.75.75 0 01.75.75v.75H12a.75.75 0 01.75.75v6A.75.75 0 0112 13H1.5a.75.75 0 01-.75-.75V2.5a.75.75 0 01.75-.75h.75V1zM9 9.25a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
					clipRule="evenodd"
				></path>
			</svg>
		);
	}
}

export function StudioLogo({classes = ''}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 280 72"
      className={`studio-logo ${classes}`}
    >
      <g clipPath="url(#clip0_568_2723)">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M44.656 3.378l24.466 24.466c4.504 4.505 4.504 11.807 0 16.312L44.656 68.621c-4.505 4.504-11.807 4.504-16.311 0L3.878 44.156c-4.504-4.505-4.504-11.807 0-16.311L28.344 3.378c4.505-4.504 11.807-4.504 16.312 0z"
          clipRule="evenodd"
        ></path>
        <path
          fill="url(#paint0_linear_568_2723)"
          fillRule="evenodd"
          d="M43.892 6.436L66.064 28.61c4.082 4.082 4.082 10.7 0 14.782L43.892 65.564c-4.082 4.082-10.7 4.082-14.782 0L6.937 43.39c-4.081-4.082-4.081-10.7 0-14.782L29.11 6.436c4.082-4.081 10.7-4.081 14.782 0z"
          clipRule="evenodd"
        ></path>
        <g
          fillRule="evenodd"
          clipRule="evenodd"
          filter="url(#filter0_i_568_2723)"
        >
          <path
            fill="#2C2E35"
            d="M42.937 8.59L63.91 29.563a9.101 9.101 0 010 12.871L42.938 63.41a9.101 9.101 0 01-12.871 0L9.09 42.436a9.101 9.101 0 010-12.872L30.066 8.59a9.101 9.101 0 0112.87 0z"
          ></path>
          <path
            fill="url(#paint1_linear_568_2723)"
            d="M42.937 8.59L63.91 29.563a9.101 9.101 0 010 12.871L42.938 63.41a9.101 9.101 0 01-12.871 0L9.09 42.436a9.101 9.101 0 010-12.872L30.066 8.59a9.101 9.101 0 0112.87 0z"
            style={{ mixBlendMode: "soft-light" }}
          ></path>
        </g>
        <g filter="url(#filter1_d_568_2723)">
          <ellipse
            cx="19.169"
            cy="36"
            fill="#72C850"
            rx="8.666"
            ry="8.666"
          ></ellipse>
        </g>
        <g filter="url(#filter2_d_568_2723)">
          <ellipse
            cx="53.834"
            cy="36"
            fill="#F45C40"
            rx="8.666"
            ry="8.666"
          ></ellipse>
        </g>
        <g filter="url(#filter3_d_568_2723)">
          <ellipse
            cx="36.502"
            cy="53.332"
            fill="#F7D117"
            rx="8.666"
            ry="8.666"
          ></ellipse>
        </g>
        <g filter="url(#filter4_d_568_2723)">
          <ellipse
            cx="36.502"
            cy="18.668"
            fill="#42C0FB"
            rx="8.666"
            ry="8.666"
          ></ellipse>
        </g>
        <path
          fill="#fff"
          d="M103.168 44.07c6.142 1.215 7.897 3.038 7.897 6.345 0 3.443-3.51 5.805-8.91 5.805-5.332 0-8.1-1.957-9.315-5.873-.405-1.282-1.62-1.822-2.903-1.822-.27 0-.607.068-.944.135-1.283.27-2.43 1.215-2.43 2.565 0 .27.067.54.135.877 1.755 6.008 6.817 9.45 15.457 9.45 9.45 0 14.985-4.792 14.985-11.272 0-7.087-3.51-9.653-12.285-11.475l-4.185-.877c-5.67-1.215-6.953-2.566-6.953-5.67 0-2.836 2.566-5.063 8.033-5.063 3.848 0 6.818 1.552 7.695 4.59.338 1.283 1.553 1.823 2.768 1.823.337 0 .742-.068 1.08-.136 1.215-.337 2.362-1.215 2.362-2.497 0-.27-.067-.54-.135-.81-1.687-4.927-6.48-8.1-13.972-8.1-8.708 0-13.973 4.185-13.973 10.327 0 6.413 3.442 9.316 11.745 10.935l3.848.743zM128.399 23.078h-5.197c-1.688 0-2.43 1.147-2.43 2.7 0 1.552.742 2.632 2.362 2.632h5.265v23.152c0 7.088 4.05 9.855 9.585 9.855 2.903 0 4.725-.54 6.683-1.485 1.012-.54 1.417-1.485 1.417-2.43 0-.472-.067-1.012-.27-1.485-.405-1.012-1.215-1.755-2.227-1.755-.405 0-.81.136-1.215.338-1.148.675-2.295 1.148-3.983 1.148-2.497 0-3.915-1.418-3.915-4.725V28.41h8.64c1.62 0 2.498-1.08 2.498-2.633 0-1.62-.81-2.7-2.498-2.7h-8.64V14.91c0-1.755-1.282-2.7-3.037-2.7-1.89 0-3.038.945-3.038 2.7v8.168zM152.317 48.255c0 8.235 4.388 13.23 12.353 13.23 6.75 0 10.665-3.443 12.757-8.167-.202 1.08-.405 2.43-.405 3.172v1.89c0 1.688 1.283 2.497 3.105 2.497 1.755 0 2.97-.877 2.97-2.7V25.373c0-1.822-1.282-2.7-3.037-2.7-1.823 0-3.105.878-3.105 2.7v18.766c0 2.632-.675 4.724-2.295 7.02-2.295 3.172-5.198 4.86-8.775 4.86-4.995 0-7.358-3.24-7.358-9.046v-21.6c0-1.822-1.282-2.7-3.105-2.7-1.822 0-3.105.878-3.105 2.7v22.883z"
        ></path>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M217.514 29.895c-.135-1.552-.27-3.51-.27-4.995V10.185c0-1.823 1.283-2.7 2.97-2.7 1.89 0 3.038.877 3.038 2.7v47.992c0 1.823-1.215 2.7-3.105 2.7-1.958 0-2.903-1.08-2.903-2.497v-1.418c0-.543.073-1.447.138-2.263.024-.3.047-.588.065-.841-2.295 4.725-6.143 7.627-12.42 7.627-9.855 0-16.065-7.763-16.065-19.913 0-11.812 6.142-19.44 16.132-19.44 6.278 0 10.058 2.97 12.42 7.763zm-.135 11.813c0-8.236-4.05-14.31-11.475-14.31-6.817 0-10.732 5.67-10.732 14.242 0 8.843 3.915 14.58 10.732 14.58 7.088 0 11.475-6.142 11.475-14.512zM230.72 11.94c0-2.565 2.025-4.522 4.59-4.522 2.498 0 4.523 1.957 4.523 4.522 0 2.633-2.025 4.59-4.523 4.59-2.565 0-4.59-1.958-4.59-4.59zm4.522 48.938c-1.89 0-3.037-.878-3.037-2.7V25.305c0-1.755 1.147-2.632 3.037-2.632 1.823 0 3.105.877 3.105 2.632v32.873c0 1.822-1.282 2.7-3.105 2.7zM244.745 41.708c0-11.678 6.547-19.575 17.482-19.575 10.8 0 17.145 7.83 17.145 19.575s-6.48 19.845-17.01 19.845c-11.137 0-17.617-7.83-17.617-19.845zm28.417-.068c0-8.505-3.848-14.31-10.733-14.31-7.29 0-11.475 5.602-11.475 14.58 0 8.573 4.05 14.445 11.003 14.445 7.357 0 11.205-5.737 11.205-14.715z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_i_568_2723"
          width="60.152"
          height="60.152"
          x="6.425"
          y="5.924"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.43"></feGaussianBlur>
          <feComposite
            in2="hardAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
          ></feComposite>
          <feColorMatrix values="0 0 0 0 0.138755 0 0 0 0 0.164163 0 0 0 0 0.251276 0 0 0 0.5 0"></feColorMatrix>
          <feBlend in2="shape" result="effect1_innerShadow_568_2723"></feBlend>
        </filter>
        <filter
          id="filter1_d_568_2723"
          width="17.332"
          height="20.546"
          x="10.503"
          y="27.334"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="3.214"></feOffset>
          <feColorMatrix values="0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.14902 0 0 0 1 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_568_2723"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_568_2723"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter2_d_568_2723"
          width="17.332"
          height="20.546"
          x="45.168"
          y="27.334"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="3.214"></feOffset>
          <feColorMatrix values="0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.14902 0 0 0 1 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_568_2723"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_568_2723"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter3_d_568_2723"
          width="17.332"
          height="20.546"
          x="27.835"
          y="44.666"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="3.214"></feOffset>
          <feColorMatrix values="0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.14902 0 0 0 1 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_568_2723"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_568_2723"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter4_d_568_2723"
          width="17.332"
          height="20.546"
          x="27.835"
          y="10.002"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="3.214"></feOffset>
          <feColorMatrix values="0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.14902 0 0 0 1 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_568_2723"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_568_2723"
            result="shape"
          ></feBlend>
        </filter>
        <linearGradient
          id="paint0_linear_568_2723"
          x1="3.876"
          x2="3.876"
          y1="3.375"
          y2="68.625"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#636A82"></stop>
          <stop offset="1" stopColor="#414554"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_568_2723"
          x1="-18.419"
          x2="36.302"
          y1="37.239"
          y2="91.256"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0.5"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0.01"></stop>
        </linearGradient>
        <clipPath id="clip0_568_2723">
          <path fill="#fff" d="M0 0H279V72H0z" transform="translate(.5)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}